import { Launch } from '@carbon/icons-react';
import { FC, MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';
import useSWR from 'swr';
import { getTenantName } from 'packages/lib/auth';

export const SampleGroupLink: FC<{
  sampleGroupToken: string;
  sampleGroupName?: string | null;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}> = ({ sampleGroupToken, sampleGroupName, onClick }) => {
  const { data: tenant } = useSWR('tenant-name', getTenantName);

  if (tenant === 'contractor' || !sampleGroupToken) {
    return null;
  }

  return (
    <Link
      to={`/sample-group/${sampleGroupToken}`}
      target="_blank"
      aria-label={`Open sample group ${sampleGroupName ?? ''}`}
      onClick={onClick}
    >
      <Launch />
    </Link>
  );
};
